import { UserInfo } from '@repo/user-types'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

export const getUserInfo = async ({
  api,
  config,
}: {
  api: AxiosInstance
  params: void
  config?: Pick<AxiosRequestConfig, 'signal'>
}): Promise<AxiosResponse<UserInfo>> => {
  return api.get<UserInfo>('/user/info', config)
}

export const patchUserInfo = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: UserInfo
}): Promise<AxiosResponse<void>> => {
  return api.patch<void>('/user/info', params)
}
